<template>
  <div>
    <h2>Categories</h2>

    <div class="card">
      <h3>新增分类</h3>
      <input v-model.trim="name" placeholder="category name" @keyup.enter="create" />
      <button @click="create" :disabled="loading || !name">创建</button>
      <p v-if="error" class="error">{{ error }}</p>
    </div>

    <div class="card">
      <div class="row">
        <h3>列表</h3>
        <button @click="load" :disabled="loading">{{ loading ? "加载中..." : "刷新" }}</button>
      </div>

      <ul>
        <li v-for="c in categories" :key="c.id">{{ c.name }}</li>
        <li v-if="!categories.length" style="color:#666;">暂无分类</li>
      </ul>

      <p v-if="error2" class="error">{{ error2 }}</p>
    </div>
  </div>
</template>

<script>
import { api, clearToken } from "@/api/client";

export default {
  name: "Categories",
  data() {
    return { categories: [], name: "", loading: false, error: "", error2: "" };
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.error2 = "";
      this.loading = true;
      try {
        const data = await api.listCategories();
        // 兼容：后端返回 {categories:[...]} 或直接数组
        this.categories = Array.isArray(data) ? data : (data.categories || []);
      } catch (e) {
        this.handleErr(e, "error2");
      } finally {
        this.loading = false;
      }
    },
    async create() {
      this.error = "";
      this.loading = true;
      try {
        await api.createCategory({ name: this.name });
        this.name = "";
        await this.load();
      } catch (e) {
        this.handleErr(e, "error");
      } finally {
        this.loading = false;
      }
    },
    handleErr(e, field) {
      const msg = e && e.message ? e.message : "请求失败";
      this[field] = msg;
      if (e && e.status === 401) {
        clearToken();
        this.$router.replace("/login");
      }
    },
  },
};
</script>

<style scoped>
.card { background:#fff; border:1px solid #eee; border-radius:12px; padding:14px; margin-top:12px; }
input { padding:8px 10px; border:1px solid #ddd; border-radius:8px; margin-right: 8px; }
button { padding:8px 10px; border:1px solid #ddd; background:#fff; border-radius:8px; cursor:pointer; }
.row { display:flex; align-items:center; justify-content:space-between; }
.error { margin-top: 8px; color:#b42318; font-size: 13px; }
</style>